import React, { FC } from 'react'
import { FlexContainer, Text2XL, TextBase, elM5, elFlex1, elHFull, elMt12 } from '@reapit/elements'
import { ErrorBoundary } from '@reapitform/utils'
import { cx } from '@linaria/core'
import { PageWrapper, BrandLogo } from '@reapitform/common-ui'
import StepNavigation from '../view/step-navigation'
import { useFormDocument } from '../view/layout/tenant-app-layout'
export const VerifyLink: FC = () => {
  const formDocumentData = useFormDocument()

  return (
    <ErrorBoundary>
      <StepNavigation hideTitleOnMobile hideNav>
        <PageWrapper hasFullPage>
          <FlexContainer isFlexColumn className={cx(elHFull, elFlex1)}>
            <BrandLogo src={formDocumentData?.agentLogoUrl || '/pwa-152x152.png'} />
            <Text2XL hasBoldText hasMargin tag="h2" hasCenteredText>
              Your link is no longer active
            </Text2XL>
            <TextBase className={cx(elM5)} hasRegularText hasCenteredText>
              This can happen if the deadline passed or if a tenant on your lease made a change request. Please reach
              out to your agent for next steps.
            </TextBase>
            <TextBase hasCenteredText hasBoldText className={elMt12}>
              {formDocumentData?.agencyName}
            </TextBase>
            <TextBase hasCenteredText tag="span" intent="primary">
              {formDocumentData?.agencyDisplayContactNumber}
            </TextBase>
          </FlexContainer>
        </PageWrapper>
      </StepNavigation>
    </ErrorBoundary>
  )
}
